import React from "react";
import MyEditor from "./components/my-editor/my-editor.component.jsx";

function App() {
  return (
    <div className="App">
      <MyEditor />
    </div>
  );
}

export default App;
